import React from 'react';
import { Navigate } from 'react-router-dom';
import WebsocketClient from '../../components/pages/websocketClient/websocketClient';
import NbaScoreboards from '../../components/pages/nbaScoreboards/nbaScoreboards';
import NascarScoreboards from '../../components/pages/nascarScoreboards/nascarScoreboards';
import PairingPage from '../../components/pages/pairing/PairingStartPage';
import Favorites_IG from '../../components/pages/favorites_ig/favorites_ig';
import routes, { getRoute } from '../../routes/route';

export const debugRoutes = [
    {
        index: true,
        element: <Navigate to="websockets" replace />,
    },
    {
        path: getRoute(routes.WEBSOCKETS),
        element: <WebsocketClient />,
    },
    {
        path: getRoute(routes.NBASCOREBOARDS),
        element: <NbaScoreboards />,
    },
    {
        path: getRoute(routes.NASCARSCOREBOARDS),
        element: <NascarScoreboards />,
    },
    {
        path: getRoute(routes.PAIRING_START),
        element: <PairingPage />,
    },
    {
        path: getRoute(routes.FAVORITES_IG),
        element: <Favorites_IG />,
    },
];